/**
 * @fileoverview GET handler for the "/companies/workspace_timezones" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { CompaniesWorkspaceTimezonesParams, CompaniesWorkspaceTimezonesResult } from "./types";

export const companiesWorkspaceTimezonesCacheKey = "/companies/workspaces_time_zones" as const;

export const getCompaniesWorkspaceTimezones = reactQueryFetcherAdapter(
  companiesWorkspaceTimezonesCacheKey,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, limit = 20, start = 0, sortby, sortdir }: CompaniesWorkspaceTimezonesParams
  ): Promise<CompaniesWorkspaceTimezonesResult> => {
    return fetch(
      "/companies/workspaces_time_zones",
      "GET",
      {
        app_group_id: appGroupId,
        limit,
        start,
        sortby,
        sortdir,
        query: serializeQueryObjects(query),
      },
      {
        signal,
      }
    );
  }
);
